import { prefixWithNameAndCode } from "./phonePrefixes";
import { isValidPhoneNumber } from "libphonenumber-js";

export const formatClientPhoneNumber = (phone_number, country_code) => {
  // If phone number is empty, return country code of the shipping country
  if (phone_number == null || phone_number == "") {
    return {
      phone_number: "",
      phone_prefix: prefixWithNameAndCode.find(
        (obj) => obj.countryCode == country_code,
      )?.value,
    };
  }

  const numberWithoutSpaces = phone_number?.replaceAll(" ", "");
  const prefixRegex =
    /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|1[234678]\d\d|441[456]\d\d|7|1)/;
  let finalPhonePrefix = "",
    finalPhoneNumber = "";

  // Extracting phone prefix with regex (if it exists)
  let phonePrefixFromRegex = numberWithoutSpaces.match(prefixRegex);
  if (phonePrefixFromRegex != null) {
    finalPhonePrefix = phonePrefixFromRegex[0];
  }

  // Remove prefix from phone number
  finalPhoneNumber = numberWithoutSpaces.replace(finalPhonePrefix, "");

  // If prefix doesnt exist, set the one available for the country given
  if (finalPhonePrefix == "") {
    finalPhonePrefix = prefixWithNameAndCode.find(
      (obj) => obj.countryCode == country_code,
    )?.value;
  }

  return {
    phone_number: finalPhoneNumber,
    phone_prefix: finalPhonePrefix,
  };
};

export const getPhonePrefixCountry = (phone_prefix, default_country) => {
  // State has phone country code
  if (phone_prefix != "") {
    return prefixWithNameAndCode
      .find((obj) => obj.value == phone_prefix)
      ?.countryCode.toLowerCase();
  }

  return default_country?.toLowerCase();
};

export const getCountryPhonePrefix = (countryLabel, countryCode) => {
  var countryPrefix = "";

  if (countryLabel != "") {
    countryPrefix = prefixWithNameAndCode.find(
      (obj) => obj.label == countryLabel,
    )?.value;
  } else if (countryCode != "") {
    countryPrefix = prefixWithNameAndCode.find(
      (obj) => obj.countryCode == countryCode?.toUpperCase(),
    )?.value;
  }

  return countryPrefix;
};

export const isPhoneNumberValid = (phoneNumber, phonePrefix) => {
  const country_iso2 = prefixWithNameAndCode.find(
    (obj) => obj.value == phonePrefix,
  )?.countryCode;

  if (!isValidPhoneNumber(phoneNumber, country_iso2) && phoneNumber) {
    return false;
  }
  return true;
};
